import { render } from "./DataAttribut.vue?vue&type=template&id=0eb0b86e"
import script from "./DataAttribut.vue?vue&type=script&lang=js"
export * from "./DataAttribut.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/distan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__